import { AppState, campaignMediaPlanForm, campaignCreativesForm } from "@store";
import { FetchingState } from "rd-redux-http";
import { AssetAttribute } from "@store";

export function adUnitAssetSelector(appState: AppState): AssetMap | undefined {
    const params = adUnitParamsSelector(appState);

    if (params && params.adFormat && params.adType) {
        const adFormats = FetchingState.getDataOrDefault(appState.mappings.adunits, []);

        const adFormat = adFormats.find(i => i.size === params.adFormat);
        if (adFormat) {
            const adType = adFormat.types.find(i => i.name === params.adType);
            if (adType) {
                return {
                    main: adType.assets.filter(a => !Array.isArray(a.type)),
                    nested: adType.assets.filter(a => Array.isArray(a.type)).map<NestedAssetDef>(a => ({
                        name: a.name,
                        title: a.title,
                        attributes: a.type as AssetAttribute[],
                        isCollection: "min" in a,
                        min: a["min"],
                        max: a["max"]
                    }))
                };
            }
        }
    }

    return undefined;
}

export interface AssetMap {
    main: AssetAttribute[];
    nested: NestedAssetDef[];
}

export interface NestedAssetDef {
    name: string;
    title: string;
    attributes: AssetAttribute[];
    isCollection: boolean;
    min: number;
    max: number;
}

export function adUnitParamsSelector(appState: AppState): AdUnitParams | undefined {
    const mediaPlanForm = campaignMediaPlanForm.selector(appState.campaignState.campaignMediaPlanForm);
    const creativesForm = campaignCreativesForm.selector(appState.campaignState.campaignCreativesForm);

    if (mediaPlanForm.fields.adUnitFormat.isParsed && creativesForm.fields.adUnitType.isParsed) {
        return {
            adType: creativesForm.fields.adUnitType.value,
            adFormat: mediaPlanForm.fields.adUnitFormat.value
        };
    }

    return undefined;
}

interface AdUnitParams {
    adType: string;
    adFormat: string;
}
